/**
 * Facebetter Error Classes
 * Platform-agnostic error handling
 */

/**
 * Facebetter error class
 */
export class FacebetterError extends Error {
  constructor(message, code = -1) {
    super(message);
    this.name = 'FacebetterError';
    this.code = code;
  }
}

/**
 * Checks if a result code indicates success
 * @param {number} result - Result code from WASM function
 * @throws {FacebetterError} If result indicates failure
 */
export function checkResult(result, errorMessage = 'Operation failed') {
  if (result !== 0) {
    throw new FacebetterError(`${errorMessage} (error code: ${result})`, result);
  }
}

